//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import thumbnail from '@/assets/imgs/mindshare.png';

export default {
  name: 'KnockPost',

  props: {
    post: {
      type: Object,
      required: true
    },
    categories: {
      type: Array,
      default() {
        return [];
      }
    }
  },

  data() {
    return {
      thumbnail,
      cats: this.post.categories.filter((cat) => cat !== 1)
    };
  },

  methods: {
    /* toDate(string) {
      const today = new Date(string);
      return today.toDateString();
    }, */

    toDate(string) {
      const today = new Date(string);
      const month = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
      return `${month[today.getMonth()]} ${today.getDate()}, ${today.getFullYear()}`;
    },

    getThumbnail() {
      if (this.post?.thumbnail?.source_url) {
        return `background-image: url("${this.post.thumbnail.source_url}");`;
      }

      return `background-image: url("${this.thumbnail}");`;
    }
  }
};
